import React, { useState, useEffect } from "react";
import "./style/financeStyle.css";
import PageLayout from "../../components/PageLayout";
import PaymentDetails from "./components/PaymentDetails";
import PaymentAccountSection from "./components/PaymentAccountSection";

const FinanceMain = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to handle window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener to listen to window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine the column size based on window width
  const columnLeftSize = windowWidth <= 1100 ? "col-md-8" : "col-md-9";
  const columnRightSize = windowWidth <= 1100 ? "col-md-4" : "col-md-3";

  return (
    <PageLayout>
      <section className="finance-main-wrapper-section">
        <div className="w-100 row">
          <div className={`${columnLeftSize} col-12`}>
            <PaymentDetails />
          </div>
          <div className={`${columnRightSize} col-12`}>
            <PaymentAccountSection />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default FinanceMain;
